var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "dashboard", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        { staticClass: "dashContent" },
        [
          _c("b-col", { attrs: { md: "3" } }, [
            _c("div", { staticClass: "userProfile" }, [
              _c("img", {
                staticClass: "avatar",
                attrs: { src: "/public/images/anonymous.jpg" },
              }),
              _vm._v(" "),
              _c("h5", { staticClass: "greetings" }, [_vm._v("Sugeng Rawuh,")]),
              _vm._v(" "),
              _c("h4", [_vm._v("Kang Mimin")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "menuBar" },
              [
                _c(
                  "b-nav",
                  { attrs: { vertical: "" } },
                  [
                    _c("b-nav-item", { attrs: { to: "/admin" } }, [
                      _vm._v("Dashboard"),
                    ]),
                    _vm._v(" "),
                    _c("b-nav-item", { attrs: { to: "/event_participant" } }, [
                      _vm._v("Participant List"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { md: "9" } },
            [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "div",
                  { staticClass: "news-list-nav", attrs: { align: "center" } },
                  [
                    _vm.page > 1
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/" + _vm.resource + "/" + (_vm.page - 1),
                            },
                          },
                          [_vm._v("< prev")]
                        )
                      : _c("a", { staticClass: "disabled" }, [
                          _vm._v("< prev"),
                        ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        " page " +
                          _vm._s(_vm.page) +
                          " of " +
                          _vm._s(_vm.maxPage) +
                          " [showing " +
                          _vm._s(_vm.itemsPerPage) +
                          " of " +
                          _vm._s(_vm.totalRows) +
                          "] "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.hasMore
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to: "/" + _vm.resource + "/" + (_vm.page + 1),
                            },
                          },
                          [_vm._v("more >")]
                        )
                      : _c("a", { staticClass: "disabled" }, [
                          _vm._v("more >"),
                        ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("transition", { attrs: { name: _vm.transition } }, [
                _vm.displayedPage > 0
                  ? _c(
                      "div",
                      { key: _vm.displayedPage, staticClass: "item-list" },
                      [
                        _c(
                          "transition-group",
                          { attrs: { tag: "ul", name: "item" } },
                          _vm._l(_vm.displayedItems.data, function (item) {
                            return _c("grid", {
                              key: item.id,
                              attrs: { item: item },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/GridContainer.vue